/**
 * AlphaGatePage — shown when a user's email domain is not on the private-alpha
 * allowlist. The backend sets alpha_blocked=true on the ensure-team response.
 *
 * The user is fully authenticated but cannot access any app content.
 */

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/contexts/AuthContext'

export default function AlphaGatePage(): React.JSX.Element {
  const { logout } = useAuth()

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle className="text-center font-serif text-xl">
            Thanks for signing up
          </CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-6">
          <p className="text-center text-sm text-muted-foreground">
            TrainLoop is currently in private alpha. We'll reach out as soon as
            your account is ready.
          </p>
          <Button variant="outline" onClick={logout}>
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
